export interface ParsedSlashCommand {
  command: string;
  args: string;
  raw: string;
}

const SLASH_RE = /^\/([A-Za-z][A-Za-z0-9-]*)(?:\s+(.*))?$/;

/** Parse a slash command from raw composer text.
 *
 * Returns `null` if the trimmed text does not begin with a `/`. The
 * returned `command` is lower-cased; `args` preserves user casing.
 */
export function parseSlashCommand(text: string): ParsedSlashCommand | null {
  const trimmed = text.trim();
  if (!trimmed.startsWith('/')) return null;
  const match = trimmed.match(SLASH_RE);
  if (!match) return null;
  return {
    command: (match[1] ?? '').toLowerCase(),
    args: (match[2] ?? '').trim(),
    raw: trimmed,
  };
}
